const is = (e, pseudo) => e.parentElement.querySelector(pseudo) === e;

export default function () {
    // console.log('init scroll');

    // safely assign IDs so it's unlikely that anything is broken by the user
    document.querySelectorAll("[data-scroll-point-id]").forEach(element => {
        const id = element.getAttribute("data-scroll-point-id")?.toLowerCase();
        if (document.querySelector(`#${id}`)) return;
        element.id = id;
    })

    // smooth scrolling for anchor links
    document.querySelectorAll("a[href^='#']").forEach(element => {
        const hash = element.getAttribute("href")?.toLowerCase();
        const target = hash != '#' ? document.querySelector(hash) : null;

        // if the target doesn't exist or element.scrollIntoView is not avaiable, fall back to default behaviour
        if (!target || !target.getBoundingClientRect || !window.scrollTo) return;

        const hideHash = (target.getAttribute("data-hide-hash") || "false") !== "false"
        if (hideHash) element.setAttribute("href", "")

        element.addEventListener("click", (e) => {
            e.preventDefault()
            !hideHash && history.pushState(null, null, hash);

            const headerHeight = document.querySelector(".main-navigation")?.getBoundingClientRect().height || 0;
            const top = target.getBoundingClientRect().top + window.scrollY - headerHeight;

            window.scrollTo({
                top,
                behavior: "smooth",
            })
            // if the element allows it, remove focus
            element.blur?.()
        })

    })
}